import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography, Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import api from 'common/api'
import useScid from 'common/use-scid'

import useCanManageApplications from '../../../useCanManageApplications'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt } from '@fortawesome/pro-solid-svg-icons'
import PreviewApplicationButton from 'routes/application/Activate/components/PreviewApplicationButton'

const useStyles = makeStyles((theme) => {
  return {
    container: {
      maxWidth: theme.spacing(68),
    },
    button: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.success.main,
      '&:hover': {
        backgroundColor: theme.palette.success.light,
      },
    },
  }
})

const ActivateApplicationStep = ({ isActive, completeStep, appConfigId }) => {
  const canCompleteStep = useCanManageApplications()
  const [activating, setActivating] = useState(false)
  const [activationError, setActivationError] = useState(false)
  const styles = useStyles()
  const scid = useScid()

  const activate = () => {
    setActivating(true)
    api
      .put(`/api/colleges/${scid}/integrations/application/configuration/${appConfigId}/verification/activate`)
      .then(async () => {
        setActivationError(false)
        completeStep()
      })
      .catch(() => {
        setActivating(false)
        setActivationError(true)
      })
  }

  return (
    <Box
      px={4}
      py={1}
    >
      <Typography>{'Are you ready to activate?'}</Typography>
      <Box
        mt={1}
        mb={3}
      >
        <Typography variant="caption">
          'By clicking the button below you are verifying that you will receive applications via Scoir for this upcoming
          application cycle beginning August 1.'
        </Typography>
      </Box>
      <Button
        className={styles.button}
        variant="contained"
        disabled={!isActive || !canCompleteStep || activating}
        onClick={activate}
      >
        <FontAwesomeIcon icon={faBolt} />
        &nbsp;Turn On Apply with Scoir
      </Button>
      <PreviewApplicationButton configurationId={appConfigId} />
      {activationError && (
        <Box mt={2}>
          <Typography
            variant="caption"
            color="error"
          >
            An error occurred while activating application.{' '}
            <Link
              href="https://www.scoir.com/support"
              target="_blank"
              rel="noreferrer"
            >
              Please contact customer support.
            </Link>
          </Typography>
        </Box>
      )}
    </Box>
  )
}

ActivateApplicationStep.propTypes = {
  isActive: PropTypes.bool.isRequired,
  appConfigId: PropTypes.string,
  completeStep: PropTypes.func.isRequired,
}

export default ActivateApplicationStep
